import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { inject, toRefs, withDefaults } from 'vue'

  import CyclingSport from '@/components/Common/Images/SportImage/CyclingSport.vue'
  import CyclingTransport from '@/components/Common/Images/SportImage/CyclingTransport.vue'
  import Hiking from '@/components/Common/Images/SportImage/Hiking.vue'
  import MountainBiking from '@/components/Common/Images/SportImage/MountainBiking.vue'
  import MountainBikingElectric from '@/components/Common/Images/SportImage/MountainBikingElectric.vue'
  import Rowing from '@/components/Common/Images/SportImage/Rowing.vue'
  import Running from '@/components/Common/Images/SportImage/Running.vue'
  import SkiingAlpine from '@/components/Common/Images/SportImage/SkiingAlpine.vue'
  import SkiingCrossCountry from '@/components/Common/Images/SportImage/SkiingCrossCountry.vue'
  import Trail from '@/components/Common/Images/SportImage/Trail.vue'
  import Walking from '@/components/Common/Images/SportImage/Walking.vue'

  interface Props {
    sportLabel: string
    color: string | null
    title?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sportLabel: null,
    color: null,
    title: { default: '' }
  },
  setup(__props: any) {

const props = __props as { sportLabel: string, color: string | null, title: string }

  

  const { color, sportLabel, title } = toRefs(props)
  const sportColors = inject('sportColors')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sport-img",
    style: _normalizeStyle({ fill: _unref(color) ? _unref(color) : _unref(sportColors)[_unref(sportLabel)] }),
    title: _unref(title) ? _unref(title) : _ctx.$t(`sports.${_unref(sportLabel)}.LABEL`)
  }, [
    (_unref(sportLabel) === 'Cycling (Sport)')
      ? (_openBlock(), _createBlock(CyclingSport, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Cycling (Transport)')
      ? (_openBlock(), _createBlock(CyclingTransport, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Hiking')
      ? (_openBlock(), _createBlock(Hiking, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Mountain Biking')
      ? (_openBlock(), _createBlock(MountainBiking, { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Mountain Biking (Electric)')
      ? (_openBlock(), _createBlock(MountainBikingElectric, { key: 4 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Rowing')
      ? (_openBlock(), _createBlock(Rowing, { key: 5 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Running')
      ? (_openBlock(), _createBlock(Running, { key: 6 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Skiing (Alpine)')
      ? (_openBlock(), _createBlock(SkiingAlpine, { key: 7 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Skiing (Cross Country)')
      ? (_openBlock(), _createBlock(SkiingCrossCountry, { key: 8 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Trail')
      ? (_openBlock(), _createBlock(Trail, { key: 9 }))
      : _createCommentVNode("", true),
    (_unref(sportLabel) === 'Walking')
      ? (_openBlock(), _createBlock(Walking, { key: 10 }))
      : _createCommentVNode("", true)
  ], 12, _hoisted_1))
}
}

})